import {
    ALL_EMPLOYEES,
    EMPLOYEE,
    CREATE_EMPLOYEE,
    UPDATE_EMPLOYEE,
    REMOVE_EMPLOYEE,
    ERR_EMPLOYEES,
} from "../actions/actionTypes";

const initialState = {
    employees: [],
    employee: [],
    loading: true,
    errors: {},
};

export default function employeeReducer(state = initialState, action) {
    const { type, payload } = action;
    // console.log(payload,"payload")
    switch (type) {
        case ALL_EMPLOYEES:
            return {
                ...state,
                employees: payload,
                loading: false,
            };
        case EMPLOYEE:
            return {
                ...state,
                employee: payload.data,
                loading: false,
            };
        case UPDATE_EMPLOYEE:
            return {
                ...state,
                // users: state.users.map((user) =>
                // 	user.id === payload.id ? { ...payload } : user
                // ),
                loading: false,
            };
        case CREATE_EMPLOYEE:
            return {
                ...state,
                users:payload,
                loading: false,
            };
        case REMOVE_EMPLOYEE:
            return {
                ...state,
                // users: state.users.users.filter((user) => user.id !== payload),
                loading: false,
            };
        case ERR_EMPLOYEES:
            return {
                ...state,
                errors: payload,
                loading: false,
            };
        default:
            return state;
    }
}
